'use client';
import { createContext } from 'react';
import { CognitoUser, Membership, UserJourneyTypes } from '../types';
import { AuthConfig } from '@aws-amplify/core';

export interface AuthContextType {
  methods: {
    federatedSignIn: () => void;
    federatedSignOut: (global?: boolean) => void;
    signUp: (
      userJourneyType?: UserJourneyTypes,
      forceSignOut?: boolean,
    ) => void;
    updateAccountData: (
      config: AuthConfig,
      userJourneyType?: UserJourneyTypes,
    ) => void;
    upgradeAccount: (
      config: AuthConfig,
      userJourneyType?: UserJourneyTypes,
    ) => void;
    handleOauthSignedIn: () => void;
    handleOauthSignedOut: () => void;
    changePassword: (
      config: AuthConfig,
      userJourneyType?: UserJourneyTypes,
    ) => void;
    deleteAccount: (config: AuthConfig, username?: string) => void;
  };
  userState: {
    user?: CognitoUser;
    membership: Membership;
    referralCode: string;
    refreshToken?: string;
    idToken?: string;
    accessToken?: string;
    isAuthenticated: boolean | null;
    checkAuthStatus: () => Promise<void>;
    hasCheckedAuth: boolean;
  };
  config: AuthConfig;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);
